import { ElMessage, MessageHandler } from "element-plus";
import { ApiError } from "~/api";
import { authStore } from "~/stores/authStore";
import { AuthStoreType } from "~/types/auth";
import { getMessageTime } from "./miscUtils";

const displayedErrors: MessageHandler[] = [];

export const clearErrors = () => {
  displayedErrors.forEach((err) => err.close());
};
const userLogin = async () => {
  await authStore.login(AuthStoreType.User).catch((err) => {
    console.warn(err);
  });
};
const logErrorToDebug = (error: any): void => {
  const pdfDebugLogElem = document.getElementById("pdfDebugLog");
  if (pdfDebugLogElem) {
    pdfDebugLogElem.innerText += error.message + "\n";
  }
};

const handleValidationErrors = (errors: any): void => {
  for (const invalidModelErr of Object.values(errors)) {
    for (const err of invalidModelErr as any) {
      const msg = err as string;
      displayedErrors.push(
        ElMessage.error({
          message: msg,
          grouping: true,
          showClose: true,
          duration: 10 * getMessageTime(msg),
        }),
      );
    }
  }
};

const handleUnauthorizedError = (): void => {
  const msg =
    'You must be logged in to access this resource. Click <a href="javascript:void(0)" id="login-link" style="color: #409EFF;">Login</a> to continue.';

  setTimeout(() => {
    const loginLink = document.getElementById("login-link");
    if (loginLink) {
      loginLink.addEventListener("click", userLogin);
    }
  }, 100);

  displayedErrors.push(
    ElMessage.error({
      message: msg,
      grouping: true,
      showClose: true,
      duration: 10 * getMessageTime(msg),
      dangerouslyUseHTMLString: true,
    }),
  );
};

const showErrorMessage = (message: string, useHTML = false): void => {
  displayedErrors.push(
    ElMessage.error({
      message,
      grouping: true,
      showClose: true,
      duration: 10 * getMessageTime(message),
      ...(useHTML && { dangerouslyUseHTMLString: true }),
    }),
  );
};

const handleApiError = (error: ApiError): void => {
  if (error.body?.errors) {
    handleValidationErrors(error.body.errors);
    return;
  }

  if (error.message === "Unauthorized") {
    handleUnauthorizedError();
    return;
  }

  const message =
    error.body?.title ||
    error.body?.message ||
    error.body?.detail ||
    error.body ||
    error.message ||
    error;

  showErrorMessage(message);
};

const handleTypeError = (error: TypeError): void => {
  let msg = error.message;
  if (msg === "Failed to fetch") {
    msg =
      "Failed to connect to the server. Please check your internet connection.";
  }
  showErrorMessage(msg);
};

export function showError(error: any, rawError?: any): void {
  console.log("Displayed error:"); // keep, to assist in debugging
  console.log(error);
  if (rawError) {
    // for developers, the raw error may have more details than the displayed error, so log it too
    console.log("Raw error:");
    console.error(rawError);
  }

  logErrorToDebug(error);

  if (typeof error === "string") {
    showErrorMessage(error);
    return;
  }

  if (error instanceof ApiError) {
    handleApiError(error);
    return;
  }

  if (error instanceof TypeError) {
    handleTypeError(error);
    return;
  }

  showErrorMessage("Error: " + error.message);
}
